<nz-card id="detail-card">

  <!--
  <nz-tabset [nzTabPosition]="'top'" [nzType]="'card'" [nzShowPagination]="true" [nzAnimated]="true">
    <nz-tab *ngFor="let tab of detail_data" [nzTitle]="tab.name | changeProteinTab" (nzSelect)="getPropertiesKeys(tab.value)">
      <nz-list nzItemLayout="horizontal">
        <nz-list-item *ngFor="let key of objectKeys">
          <nz-list-item-meta
            nzDescription="{{key}}"
          >
            <nz-list-item-meta-title>
              <p style="word-wrap: break-word; word-break: break-all;">{{ tab.value[key] }}</p>
            </nz-list-item-meta-title>
          </nz-list-item-meta>
        </nz-list-item>
        <nz-list-empty *ngIf="objectKeys == null"></nz-list-empty>
      </nz-list>
    </nz-tab>
  </nz-tabset>
  -->

  <nz-tabset [nzTabPosition]="'top'" [nzType]="'card'" [nzShowPagination]="true" [nzAnimated]="true">


    <nz-tab nzTitle="Basic Info">
      <nz-list nzItemLayout="horizontal">
        <nz-list-item *ngIf="detail_data != null">
          <nz-list-item-meta
            nzDescription="Name"
          >
            <nz-list-item-meta-title>
              <p class="value-str" >{{ detail_data.basicInfo.name }}</p>
            </nz-list-item-meta-title>
          </nz-list-item-meta>
        </nz-list-item>
        <nz-list-item *ngIf="detail_data != null">
          <nz-list-item-meta
            nzDescription="Full Name"
          >
            <nz-list-item-meta-title>
              <p class="value-str" >{{ detail_data.basicInfo.protein_fullName }}</p>
            </nz-list-item-meta-title>
          </nz-list-item-meta>
        </nz-list-item>
        <nz-list-item *ngIf="detail_data != null">
          <nz-list-item-meta
            nzDescription="Dataset"
          >
            <nz-list-item-meta-title>
              <p class="value-str" >{{ detail_data.basicInfo.dataset }}</p>
            </nz-list-item-meta-title>
          </nz-list-item-meta>
        </nz-list-item>
        <nz-list-item *ngIf="detail_data != null">
          <nz-list-item-meta
            nzDescription="Accession"
          >
            <nz-list-item-meta-title>
              <p class="value-str" >{{ detail_data.basicInfo.accession }}</p>
            </nz-list-item-meta-title>
          </nz-list-item-meta>
        </nz-list-item>
        <nz-list-item *ngIf="detail_data != null">
          <nz-list-item-meta
            nzDescription="Created Date"
          >
            <nz-list-item-meta-title>
              <p class="value-str" >{{ detail_data.basicInfo.created_date }}</p>
            </nz-list-item-meta-title>
          </nz-list-item-meta>
        </nz-list-item>
        <nz-list-item *ngIf="detail_data != null">
          <nz-list-item-meta
            nzDescription="Modified Date"
          >
            <nz-list-item-meta-title>
              <p class="value-str" >{{ detail_data.basicInfo.modified_date }}</p>
            </nz-list-item-meta-title>
          </nz-list-item-meta>
        </nz-list-item>
        <nz-list-item *ngIf="detail_data != null">
          <nz-list-item-meta
            nzDescription="Gene"
          >
            <nz-list-item-meta-title>
              <p class="value-str" >{{ detail_data.basicInfo.gene_name }}</p>
            </nz-list-item-meta-title>
          </nz-list-item-meta>
        </nz-list-item>
        <nz-list-item *ngIf="detail_data != null">
          <nz-list-item-meta
            nzDescription="Protein Existence"
          >
            <nz-list-item-meta-title>
              <p class="value-str" >{{ detail_data.basicInfo.proteinExistence }}</p>
            </nz-list-item-meta-title>
          </nz-list-item-meta>
        </nz-list-item>
        <nz-list-empty  *ngIf="detail_data == null"></nz-list-empty>
      </nz-list>
    </nz-tab>

    <nz-tab nzTitle="Sequence">
      <nz-list nzItemLayout="horizontal">
        <nz-list-item *ngIf="detail_data != null">
          <nz-list-item-meta
            nzDescription="Length"
          >
            <nz-list-item-meta-title>
              <p class="value-str" >{{ detail_data.sequence.sequence_length }}</p>
            </nz-list-item-meta-title>
          </nz-list-item-meta>
        </nz-list-item>
        <nz-list-item *ngIf="detail_data != null">
          <nz-list-item-meta
            nzDescription="Mass"
          >
            <nz-list-item-meta-title>
              <p class="value-str" >{{ detail_data.sequence.sequence_mass }}</p>
            </nz-list-item-meta-title>
          </nz-list-item-meta>
        </nz-list-item>
        <nz-list-item *ngIf="detail_data != null">
          <nz-list-item-meta
            nzDescription="Checksum"
          >
            <nz-list-item-meta-title>
              <p class="value-str" >{{ detail_data.sequence.sequence_checksum }}</p>
            </nz-list-item-meta-title>
          </nz-list-item-meta>
        </nz-list-item>
        <nz-list-item *ngIf="detail_data != null">
          <nz-list-item-meta
            nzDescription="Sequence"
          >
            <nz-list-item-meta-title>
              <p class="value-str" >{{ detail_data.sequence.sequence }}</p>
            </nz-list-item-meta-title>
          </nz-list-item-meta>
        </nz-list-item>
        <nz-list-empty  *ngIf="detail_data == null"></nz-list-empty>
      </nz-list>
    </nz-tab>


    <nz-tab nzTitle="Organism">
      <nz-list nzItemLayout="horizontal">
        <nz-list-item *ngIf="detail_data != null">
          <nz-list-item-meta
            nzDescription="Scientific Name"
          >
            <nz-list-item-meta-title>
              <p class="value-str" >{{ detail_data.organism.organism_scientific_name }}</p>
            </nz-list-item-meta-title>
          </nz-list-item-meta>
        </nz-list-item>
        <nz-list-item *ngIf="detail_data != null">
          <nz-list-item-meta
            nzDescription="Common Name"
          >
            <nz-list-item-meta-title>
              <p class="value-str" >{{ detail_data.organism.organism_common_name }}</p>
            </nz-list-item-meta-title>
          </nz-list-item-meta>
        </nz-list-item>
        <nz-list-item *ngIf="detail_data != null">
          <nz-list-item-meta
            nzDescription="Synonym Name"
          >
            <nz-list-item-meta-title>
              <p class="value-str" >{{ detail_data.organism.organism_synonym_name }}</p>
            </nz-list-item-meta-title>
          </nz-list-item-meta>
        </nz-list-item>
        <nz-list-item *ngIf="detail_data != null">
          <nz-list-item-meta
            nzDescription="Host"
          >
            <nz-list-item-meta-title>
              <p class="value-str" >{{ detail_data.organism.organismHost }}</p>
            </nz-list-item-meta-title>
          </nz-list-item-meta>
        </nz-list-item>
        <nz-list-item *ngIf="detail_data != null">
          <nz-list-item-meta
            nzDescription="Lineage"
          >
            <nz-list-item-meta-title>
              <p class="value-str" >{{ detail_data.organism.organism_lineage }}</p>
            </nz-list-item-meta-title>
          </nz-list-item-meta>
        </nz-list-item>
        <nz-list-item *ngIf="detail_data != null">
          <nz-list-item-meta
            nzDescription="DB Reference"
          >
            <nz-list-item-meta-title>
              <p class="value-str" >{{ detail_data.organism.organism_dbReference }}</p>
            </nz-list-item-meta-title>
          </nz-list-item-meta>
        </nz-list-item>
        <nz-list-empty *ngIf="detail_data == null"></nz-list-empty>
      </nz-list>
    </nz-tab>


    <nz-tab nzTitle="Keywords">
      <nz-list nzItemLayout="horizontal">
        <nz-list-item *ngIf="detail_data != null">
          <nz-list-item-meta
            nzDescription="Keywords"
          >
            <nz-list-item-meta-title>
              <p class="value-str" >{{ detail_data.keywords.keywords }}</p>
            </nz-list-item-meta-title>
          </nz-list-item-meta>
        </nz-list-item>
        <nz-list-empty *ngIf="detail_data == null"></nz-list-empty>
      </nz-list>
    </nz-tab>


    <nz-tab nzTitle="Feature">
      <nz-list nzItemLayout="horizontal">
        <nz-list-item *ngIf="detail_data != null">
          <nz-list-item-meta
            nzDescription="Feature"
          >
            <nz-list-item-meta-title>
              <p class="value-str" >{{ detail_data.feature.feature }}</p>
            </nz-list-item-meta-title>
          </nz-list-item-meta>
        </nz-list-item>
        <nz-list-empty *ngIf="detail_data == null"></nz-list-empty>
      </nz-list>
    </nz-tab>


    <nz-tab nzTitle="DB Reference">
      <nz-list nzItemLayout="horizontal">
        <nz-list-item *ngIf="detail_data != null">
          <nz-list-item-meta
            nzDescription="DB Reference"
          >
            <nz-list-item-meta-title>
              <p class="value-str" >{{ detail_data.dbRef.dbReference }}</p>
            </nz-list-item-meta-title>
          </nz-list-item-meta>
        </nz-list-item>
        <nz-list-empty *ngIf="detail_data == null"></nz-list-empty>
      </nz-list>
    </nz-tab>


    <nz-tab nzTitle="Cited">
      <nz-list nzItemLayout="horizontal">
        <nz-list-item *ngIf="detail_data != null">
          <nz-list-item-meta
            nzDescription="Cited"
          >
            <nz-list-item-meta-title>
              <p *ngIf="detail_data.cited.reference_id != null" class="value-str" >{{ detail_data.cited.reference_id }}</p>
              <p *ngIf="detail_data.cited.reference_id == null">No Data</p>
            </nz-list-item-meta-title>
          </nz-list-item-meta>
        </nz-list-item>
        <nz-list-empty *ngIf="detail_data == null"></nz-list-empty>
      </nz-list>
    </nz-tab>


  </nz-tabset>


</nz-card>